import DataTable from "../../components/common/DataTable";
import { modals } from "@mantine/modals";
import { Button, Text, Title } from "@mantine/core";
import { notifications } from "@mantine/notifications";

import React from "react";
import { CSVLink } from "react-csv";
import { Link, useNavigate, useParams } from "react-router-dom";
import Head from "../../components/common/Head";
import useValidate from "../../hooks/useValidate";
import { useDeleteSeason } from "../../utils/mutations";
import { useSeasonsBySeries, useSeriesById } from "../../utils/queries";
import useStore from "../../utils/store";

const Seasons = () => {
  
  const user = useStore((state) => state.user);
  const navigate = useNavigate();

  const { seriesId } = useParams();
  const { data: series } = useSeriesById(seriesId);
  const {
    data: seasons,
    isLoading: loadingSeasons,
    refetch: refetchSeasons,
  } = useSeasonsBySeries(seriesId);
  const deleteSeason = useDeleteSeason();
  useValidate();

  if (!user?.getAllSeries) {
    return (
      <Text type="secondary">
        You don't have permission to view seasons
      </Text>
    );
  }

  const handleDelete = async (id) => {
    const [success] = await deleteSeason.mutateAsync(id);
    if (success) {
      refetchSeasons();
    }
  };

  const csvData = (seasons || []).map((row) => ({
    name: row.name || "",
    description: row.description || "",
    position: row.position || "",
    releaseDate: row.releaseDate || "",
    isEnable: row.isEnable ? "Yes" : "No",
  }));

  return (
    <div className="w-full flex flex-col gap-4">
      
      <Head
        title={`${series?.name} - Seasons`}
        button={user?.addSeries ? "Add Season" : null}
        onClick={
          user?.addSeries ? () => navigate(`/seasons/add/${seriesId}`) : null
        }
      />
      {seasons && seasons.length > 0 && (
        <div className="flex justify-end mb-4">
          <CSVLink
            data={csvData}
            filename={`seasons-${series?.name || seriesId}-${new Date().toISOString().slice(0, 10)}.csv`}
            target="_blank"
          >
            <Button>Export as CSV</Button>
          </CSVLink>
        </div>
      )}
      <DataTable
        dataSource={seasons}
        loading={loadingSeasons}
        columns={[
          {
            title: "Action",
            dataIndex: "action",
            key: "action",
            render: (text, record) => (
              <div
                style={{ display: "flex", flexDirection: "column", gap: 10 }}
              >
                {user?.updateSeries && (
                  <Link to={`/seasons/edit/${seriesId}/${record._id}`}>
                    <Button style={{ width: "100%" }}>
                      Edit
                    </Button>
                  </Link>
                )}
                {user?.deleteSeries && (
                  <span onClick={() => modals.openConfirmModal({ title: "Are you sure you want to delete this item?", labels: { confirm: "Yes", cancel: "No" }, onConfirm: () => handleDelete(record._id) })}>
                    <Button color="red">
                      Delete
                    </Button>
                  </span>
                )}
              </div>
            ),
          },
          { title: "Name", dataIndex: "name", key: "name" },
          {
            title: "Description",
            dataIndex: "description",
            key: "description",
          },
          {
            title: "Release Date",
            dataIndex: "releaseDate",
            key: "releaseDate",
          },
          {
            title: "Status",
            dataIndex: "isEnable",
            key: "isEnabled",
            render: (isEnabled) => (
              <span style={{ color: isEnabled ? "#52c41a" : "#ff4d4f" }}>
                {isEnabled ? "Enabled" : "Disabled"}
              </span>
            ),
          },
          {
            title: "Episodes",
            dataIndex: "episodes",
            key: "episodes",
            render: (text, record) => (
              <Link to={`/episodes/${record._id}`}>
                <Button>Episodes</Button>
              </Link>
            ),
          },
        ]}
      />
    </div>
  );
};

export default Seasons;
